import { createContext } from "react";
import type {
  CreatePickupPayload,
  Pickup,
  UpdatePickupPayload,
} from "../../../api/pickups";

// This is the information on our users. So all userdata related to THEIR pickup.

export interface UserPickupContextType {
  pickup: Pickup | null;
  loading: boolean;
  error: string | null;
  fetchPickup: (userId: string) => Promise<void>;
  createPickup: (data: CreatePickupPayload) => Promise<void>;
  updatePickup: (id: string, data: UpdatePickupPayload) => Promise<void>;
  deletePickup: () => Promise<void>;
  refreshPickup: (userId: string) => Promise<void>;
}

export const UserPickupContext = createContext<UserPickupContextType>({
  pickup: null,
  loading: false,
  error: null,
  fetchPickup: () => Promise.resolve(),
  createPickup: () => Promise.resolve(),
  updatePickup: () => Promise.resolve(),
  deletePickup: () => Promise.resolve(),
  refreshPickup: () => Promise.resolve(),
});
